module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sitetable"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sites,
      "empty-text": "No Sites Found"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', [_c('strong', [_vm._v(" Primary Contact ")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(props.row.contact.name || '') + " ")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(props.row.contact.phone || '') + " ")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(props.row.contact.email || '') + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Address",
      "prop": "address",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Longitude",
      "prop": "longitude",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Latitude",
      "prop": "latitude",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Zoom",
      "prop": "zoom",
      "header-align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Delay",
      "prop": "delay",
      "header-align": "center",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Standby",
      "prop": "standby",
      "header-align": "center",
      "width": "100"
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "header-align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.id
          },
          on: {
            "view": _vm.viewFields,
            "edit": function($event) {
              _vm.editSite(props.row)
            },
            "delete": _vm.deleteSite
          }
        })]
      }
    }])
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e23245dc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Sites/SiteTable.vue
// module id = 1003
// module chunks = 10